export const checkIfJobsExist = (companies: any[]) => {
  const jobLocations = companies.flatMap((item: any) =>
    item.departments.flatMap((elem: any) => elem.jobLocations)
  );

  return !!jobLocations.length;
};
